module.exports = __webpack_public_path__ + "static/media/Flaticon.6884e0ab.woff";